module.exports = __webpack_public_path__ + "img/handle_banner2.f682e19c.png";